import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import {dot, dash} from 'effects/midi/tidal/parser.js';
import {getBlocks, calculateRules} from './calculateRules.js';
import {RULES} from "messaging/message-types.js";
import {
    otherwise,
    REST,
    after,
    when,
    before,
    REGULAR,
    PIANO,
    LEGATO,
    STACCATO,
    PIANISSIMO,
    ACCENT} from 'effects/midi/scripting/trules.js';

export default superclass => class extends superclass  {

    calculateRules() {
        let a = new Date().getTime();
        let rules = calculateRules(this.cells, this.size);
        let b = new Date().getTime();
        this.rules = rules;
        this.sendMessage(RULES, rules);
        this.sendMessage("density", this.getDensity());
    }

    getDensity() {
        let blocks = getBlocks(this.cells, this.size);
        let sum = 0;
        let count=0;
        for (let block of blocks) {
            sum+=block.length;
            count+=5;
        }
        return sum/count;
    }
}


